module.exports = __webpack_public_path__ + "static/media/noclass3.162c33c7.png";